<div class="card">
  <div class="checkmark-container">
    <i class="checkmark">✓</i>
  </div>
  <h1>Success</h1>
  <p>Thank you for your subscription!<br />Your subscription is now active.</p>
</div>
